export default "__VITE_ASSET__CnQsJruI__"